module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-circle-8a063bdc4aa7a2041d69bf174b9c7cd3.svg";